'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconFileDrawer, iconFileDrawerTag } from '@ni/nimble-components/dist/esm/icons/file-drawer';
import { wrap } from '../../utilities/react-wrapper';

export type { IconFileDrawer };
export { iconFileDrawerTag };
export const NimbleIconFileDrawer = wrap(IconFileDrawer);